import axios from 'axios';
import { clearAuthSession, getAuthSession, getLoginPathForRole, getValidAuthSession } from '../utils/authSession';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9000';
const API_TIMEOUT = Number(process.env.REACT_APP_API_TIMEOUT) || 30000;
const defaultConfig = {
  timeout: API_TIMEOUT,
  headers: { 'Content-Type': 'application/json' },
};

const axiosInstance = axios.create({
  ...defaultConfig,
  baseURL: `${BASE_URL}/claimpolis`,
});

const apiClient = axios.create({
  ...defaultConfig,
  baseURL: BASE_URL,
});

// Alias dipertahankan sementara agar modul lama dapat dimigrasikan bertahap.
const axiosInstance9000 = apiClient;
const axiosInstanceLocal = apiClient;

const setAuthInterceptor = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const storedSession = getAuthSession();
      const hasStoredToken = Boolean(storedSession.token);
      const session = getValidAuthSession();
      if (hasStoredToken && !session) {
        window.location.replace(getLoginPathForRole(storedSession.role));
        return Promise.reject(new axios.CanceledError("Sesi telah berakhir."));
      }
      if (session?.token) {
        config.headers.Authorization = `Bearer ${session.token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const session = getAuthSession();
      const hadSession = Boolean(session.token);
      if (error.response?.status === 401 && hadSession) {
        clearAuthSession();
        const loginPath = getLoginPathForRole(session.role);
        if (window.location.pathname !== loginPath) {
          window.location.replace(loginPath);
        }
      }
      return Promise.reject(error);
    }
  );
};

setAuthInterceptor(axiosInstance);
setAuthInterceptor(apiClient);

export default axiosInstance;
export { apiClient, axiosInstance, axiosInstance9000, axiosInstanceLocal };
